export default {
      id: "documents-usage",
      viewBox: "0 0 21.14 25",
      url: __webpack_public_path__ + "assets/images/lantern-icons.svg#documents",
      toString: function () {
        return this.url;
      }
    }